import { render, staticRenderFns } from "./V1Client.vue?vue&type=template&id=df01a0dc&scoped=true&"
import script from "./V1Client.vue?vue&type=script&lang=js&"
export * from "./V1Client.vue?vue&type=script&lang=js&"
import style0 from "./V1Client.vue?vue&type=style&index=0&id=df01a0dc&scoped=true&lang=css&"
import style1 from "./V1Client.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df01a0dc",
  null
  
)

export default component.exports